export default __webpack_public_path__ + "static/media/pe.e7a9389a.svg";